import { Logger } from '../utils/logger';

export abstract class BaseManager {
    protected name: string;
    protected logger: Logger;
    protected initialized: boolean = false;

    constructor(name: string) {
        this.name = name;
        this.logger = new Logger(undefined, name);
    }

    public initialize(): void {
        if (this.initialized) {
            this.logger.warn('Manager already initialized');
            return;
        }

        this.logger.info('Initializing manager');
        this.initialized = true;
    }

}